import { render, staticRenderFns } from "./TableRoles.vue?vue&type=template&id=9e1e1b80"
import script from "./TableRoles.vue?vue&type=script&lang=js"
export * from "./TableRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports